// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'b5b3359d973ad7b970a7ab40bb6acd156feef11e';
export const BUILD_NUMBER = '221';
export const BUILD_TIMESTAMP = '2026-08-25T12:11:37.934Z';
